import React, { useState, useEffect } from 'react'
import { Layout, Row, Col, Switch, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { Can } from '../../refactory/modules/access-control/infrastructure/roles-permissions/access-control'
import { SubModulePerms } from '../../refactory/modules/access-control/domain/module'
import FlagList from './flag-list/flag-list.component'
import JobDetail from './job-detail/job-detail.component'
import { StoreJobList, Consumer } from './flag.store'
import { updateShowAssignedJobs } from '@actions/jobList'
import EmptyState from '../../refactory/kernel/infrastructure/empty-state.component'
import { HistoricalProvider } from '../../refactory/modules/jobs/infrastructure/job-detail/historical.context'
import { FeaturesConfigurationProvider } from '../../refactory/modules/jobs/infrastructure/job-detail/features-configuration.context'

const FlagManagement = (props) => {
  const { t } = useTranslation()
  const [isMount, setIsMount] = useState(false)
  const { currentUser = {}, featureFlags } = props

  const changeShowAssignedJobs = (checked, dispatch) => {
    const {
      user: { id: myId }
    } = currentUser
    updateShowAssignedJobs(checked, myId, dispatch)
  }

  useEffect(() => {
    if (!isMount) {
      setIsMount(true)
    }
    return () => {
      setIsMount(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <React.Fragment>
      {isMount ? (
        <StoreJobList>
          <Consumer>
            {(value) => {
              const { state, dispatch } = value
              const {
                selectedJob,
                jobStatistics: { assignedJobs, unviewedJobs, viewedJobs, myAssignedJobs },
                showAssignedJobs
              } = state
              return (
                <Layout>
                  <div className='jobs-container'>
                    <Row className='jobs-statistics' gutter={16} align='stretch'>
                      {Can([SubModulePerms.FLA_GENERAL_ALL_SEE]) && (
                        <Col xs={24} sm={8} lg={4}>
                          <Row justify='space-between' align='middle'>
                            <Col span={6}>
                              <Switch
                                size='small'
                                checked={showAssignedJobs}
                                onChange={(checked) => changeShowAssignedJobs(checked, dispatch)}
                              />
                            </Col>
                            <Col className='title' span={14}>
                              {t('jobs.jobList.counters.myAssignedJobs')}
                            </Col>
                            <Col className='data' span={4}>
                              {myAssignedJobs}
                            </Col>
                          </Row>
                        </Col>
                      )}
                      <Col xs={24} sm={8} lg={4}>
                        <Row justify='space-between' align='middle'>
                          <Col className='title' span={20}>
                            {t('jobs.jobList.counters.assigned')}
                          </Col>
                          <Col className='data' span={4}>
                            {assignedJobs}
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} sm={8} lg={4}>
                        <Row justify='space-between' align='middle'>
                          <Col className='title'>{t('jobs.jobList.counters.unviewed')}</Col>
                          <Col className='data'>{unviewedJobs}</Col>
                        </Row>
                      </Col>
                      <Col xs={24} sm={8} lg={4}>
                        <Row justify='space-between' align='middle'>
                          <Col className='title'>{t('jobs.jobList.counters.viewed')}</Col>
                          <Col className='data'>{viewedJobs}</Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col className='jobs-list-container' span={6}>
                        <div>
                          <FlagList {...value} currentUser={props.currentUser} />
                        </div>
                      </Col>
                      {selectedJob ? (
                        <HistoricalProvider>
                          <FeaturesConfigurationProvider>
                            <JobDetail
                              dispatch={dispatch}
                              selectedJob={selectedJob}
                              currentUser={props.currentUser}
                              featureFlags={featureFlags}
                            />
                          </FeaturesConfigurationProvider>
                        </HistoricalProvider>
                      ) : (
                        <Col span={18}>
                          <Row className='empty-job-container' type='flex' justify='space-around' align='middle'>
                            <Col span={24} style={{ display: 'flex' }}>
                              <Space className='empty-job'>
                                <EmptyState
                                  subtitle={t('empty.job')}
                                  image='/empty.png'
                                  imageStyle={{
                                    height: 60
                                  }}
                                />
                              </Space>
                            </Col>
                          </Row>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Layout>
              )
            }}
          </Consumer>
        </StoreJobList>
      ) : null}
    </React.Fragment>
  )
}

export default FlagManagement
